export default __webpack_public_path__ + "static/media/Wakaf 2.f8849db3.png";